import { getAllAssignedVariations } from './getAllAssignedVariations.js';
export async function isInVariation(variationId) {
    return (await getAllAssignedVariations()).includes(variationId);
}
export async function isInAnyVariation(...variationIds) {
    const variations = isNestedArray(variationIds) ? variationIds[0] : variationIds;
    for (const variationId of variations) {
        if (await isInVariation(variationId)) {
            return true;
        }
    }
    return false;
}
const isNestedArray = (arr) => {
    return Array.isArray(arr[0]);
};
//# sourceMappingURL=isInVariation.js.map